import { call, put, select, takeEvery } from 'redux-saga/effects';
import { produce } from 'utility/general';
import API from 'api/call';
import { safeSaga } from 'store';
import { FINAL_REPORT } from 'utility/postApprovalLookUp';
import { GET_FINAL_REPORT, SAVE_FINAL_REPORT, SET_FINAL_REPORT } from 'store/key';
import { setGlobal } from 'store/global/reducer';

const initialState = {
    remoteDetail: {},
    isLoading: false,
};

function* saveFinalReport(action) {
    const { callback, data, final, onError, isSubmit = false } = action.payload;

    // data should include reportId / siteId & appId

    try {
        const api = isSubmit ? API.finalReport.submitFinalReport : API.finalReport.saveFinalReport;

        const res = yield call(api, data);

        const newReportId = res.data.result?.reportId;

        callback?.(newReportId);
    } catch (error) {
        console.log('create/save progress failed:', error);
        onError?.();
    }

    final?.();
}

function* getFinalReport(action) {
    const { docType = FINAL_REPORT, reportId, appId, isLoading = true, final, callback, onPermissionError } = action.payload;
    const { finalReport } = yield select();

    try {
        // clear data from another form
        yield put(
            setGlobal({
                postApprovalReportData: {
                    [reportId]: {
                        showNavigationSubNo: null,
                        showNavigationStatus: null,
                    },
                },
            }),
        );

        let data = { docType };

        if (reportId) {
            data.reportId = reportId;
        } else {
            data.appId = appId;
        }

        if (isLoading) {
            yield put({
                type: SET_FINAL_REPORT,
                payload: {
                    isLoading: true,
                },
            });
        }

        const res = yield call(API.postApprovalActivities.getReportDetail, data);
        const detail = res.data.result;
        finalReport.remoteDetail = detail;
        finalReport.isLoading = false;

        yield put({
            type: SET_FINAL_REPORT,
            payload: finalReport,
        });

        callback?.(finalReport);
    } catch (error) {
        console.log('get susar report detail failed:', error);

        // if(error?.response?.data?.errorMessage.includes('You do not have')) {
            
        // }

        return onPermissionError?.()

        // yield put({
        //     type: SET_FINAL_REPORT,
        //     payload: {
        //         isLoading: false,
        //     },
        // });
    }

    final?.();
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FINAL_REPORT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchFinalReport() {
    yield takeEvery(GET_FINAL_REPORT, safeSaga(getFinalReport));
    yield takeEvery(SAVE_FINAL_REPORT, safeSaga(saveFinalReport));
}

export default reducer;
